import { Typography } from "@povio/ui";

interface IProps {
  title: string | React.ReactNode;
  subTitle: string | React.ReactNode;
  sectionId: string;
}

const ProfileItemTitle = ({ title, subTitle, sectionId }: IProps) => {
  const isSubTitleString = typeof subTitle === "string";

  const subTitleComponent = isSubTitleString ? (
    <Typography
      size="label-4"
      className="text-text-default-3"
      as="span"
      data-testid={`profile-item-sub-title-${sectionId}`}
    >
      {subTitle}
    </Typography>
  ) : (
    subTitle
  );

  return (
    <div>
      <Typography
        size="label-4"
        data-testid={`profile-item-title-${sectionId}`}
      >
        {title}
      </Typography>
      {subTitleComponent}
    </div>
  );
};

export default ProfileItemTitle;
